import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

/**
  * Puts given element inside a PDF and downloads the PDF with the given name.
  * @param htmlElement   The html element to download in a PDF file. 
  * @param name          The name of the PDF file to download.
*/
export const downloadElementAsPdf = async (htmlElement: HTMLElement, name: string) => {
  if (htmlElement !== undefined || htmlElement !== null) {

    const element = htmlElement;
    const canvas = await html2canvas(element);
    const image = canvas.toDataURL('image/png');

    const pdf = new jsPDF();

    pdf.addImage(image, 'PNG', 0, 0, 54, 86);

    pdf.save(`${name}.pdf`);

  }
};